import { render, staticRenderFns } from "./CustomerGroupAdded.vue?vue&type=template&id=8ec92330&scoped=true"
import script from "./CustomerGroupAdded.vue?vue&type=script&lang=js"
export * from "./CustomerGroupAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec92330",
  null
  
)

export default component.exports